const url = window.location.href.toString();

import portalConfigurations from './portalConfigurations';

function setUrl() {
  if (url.includes('localhost') || url.includes('dev.podemorar')) {
    return portalConfigurations['dev'];
  }

  if (url.includes('qa.podemorar')) {
    return portalConfigurations['qa'];
  }

  if (url.includes('stage.podemorar')) {
    return portalConfigurations['stage'];
  }

  if (url.includes('testes.podemorar')) {
    return portalConfigurations['testes'];
  }

  return portalConfigurations['prod'];
}

let portalEnvironment = setUrl();

export default portalEnvironment;
